import {ORGANIZATION_SERVER} from "@/api";
import RestResource from "@/api/rest/rest-resource";
import {athubAxios} from "@/util";

const roleTree = new RestResource({server: ORGANIZATION_SERVER, resource: 'roleTree'});

roleTree.queryTreeInfo = (referenceId) => {
    return new Promise((resolve, reject) => {
        athubAxios.get(`${ORGANIZATION_SERVER}/roleTree/treeInfo/referenceId/${referenceId}`).then(res => {
            if (res.status == 200) {
                resolve(res.data.data);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

roleTree.queryTreeNodeByPid = (pid) => {
    return new Promise((resolve, reject) => {
        athubAxios.get(`${ORGANIZATION_SERVER}/roleTree/treeInfo/pid/${pid}`).then(res => {
            if (res.status == 200) {
                resolve(res.data.data);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

roleTree.queryParentReferenceId = (referenceId) => {
    return new Promise((resolve, reject) => {
        athubAxios.get(`${ORGANIZATION_SERVER}/roleTree/parentTreeInfo/referenceId/${referenceId}`).then(res => {
            if (res.status == 200) {
                resolve(res.data.data);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

roleTree.queryChildReferenceId = (referenceId) => {
    return new Promise((resolve, reject) => {
        athubAxios.get(`${ORGANIZATION_SERVER}/roleTree/childTreeInfo/referenceId/${referenceId}`).then(res => {
            if (res.status == 200) {
                resolve(res.data.data);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

/**
 * 平铺的整棵角色树
 * @returns {Promise<unknown>}
 */
roleTree.queryFlatEntireTree = () => {
    return new Promise((resolve, reject) => {
        athubAxios.get(`${ORGANIZATION_SERVER}/roleTree/flatEntireTree`).then(res => {
            if (res.status == 200) {
                resolve(res.data.data);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

/**
 * 通过角色id在树种获取树的实体
 * @param referenceId
 * @returns {Promise<unknown>}
 */
roleTree.queryTreeNodeByReferenceId = (referenceId) => {
    return new Promise((resolve, reject) => {
        athubAxios.get(`${ORGANIZATION_SERVER}/roleTree/treeNode/referenceId/${referenceId}`).then(res => {
            if (res.status == 200) {
                resolve(res.data.data);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

export default roleTree;
